var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "rotate(90 16 16)",
    fill: "#8A49D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_31795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8 11.5888 11.5888 8 16 8C17.7816 8 19.4678 8.57318 20.8765 9.6576L19.0174 12.0725C18.1464 11.4021 17.103 11.0476 16 11.0476C13.2693 11.0476 11.0476 13.2693 11.0476 16C11.0476 18.7307 13.2693 20.9524 16 20.9524C18.1994 20.9524 20.0684 19.5114 20.7125 17.5238H16V14.4762H24V16C24 20.4112 20.4112 24 16 24C11.5888 24 8 20.4112 8 16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_31795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleContact);
export default __webpack_public_path__ + "static/media/Google-Contact.86b3993a5e518e2f3d6661364a795b12.svg";
export { ForwardRef as ReactComponent };